export const SET_PRINCIPAL = 'SetPrincipal';
export const SET_ACCESS_TOKEN = 'SetAccessToken';
export const SET_REQUEST_VERIFICATION_TOKEN = 'SetRequestVerificationToken';
export const SET_DO_LOGOUT = 'SetDoLogout';
export const SET_ACCESS_TOKEN_COOKIE = 'SetAccessTokenCookie';
